// Adds zero when necessary. 9 => 09
export default function addZero(num: number) {
  return String(num).padStart(2, '0');
}
